import dayjs from 'dayjs';

export type SelectDataType = {
  mesid: number;
  devIndex: number;
  year: number;
  month: number;
}

export type FeatureParameterDayData = {
  Day: Date;
  Value: string;
  Judgement: number;
}

export type FeatureParameterDatas = {
  FeatureParameterDatas: FeatureParameterDayData[];
  ItemName: string;
  ItemSpeed: number;
}

export type FeatureParameterDataType = {
  DeviceInfo: MeasureInfoType;
  Datas: FeatureParameterDatas[];
}

export type MeasureInfoType = {
  AiCard: number;
  AiCh: number;
  DevIndex: number;
  DevName: string;
  DevNo: string;
  EntryNo: number;
  ItemName: string;
  ItemNameNo: number;
  KindNo: number;
  LogStart: string;
  MesName: string;
  PlcNo : number;
  SetNo: number;
  Speed: number;

  selectDay: string;
  selectTime: string;
  name: string;
  id: number;
};

export const CreateDefalutMeasureInfoType = (): MeasureInfoType => {

  var dt: MeasureInfoType =
  {
      AiCard: 0,
      AiCh: 0,
      DevIndex: 0,
      DevName: "",
      DevNo: "",
      EntryNo: 0,
      ItemName: "",
      ItemNameNo: 0,
      KindNo: 0,
      LogStart: "",
      MesName:"",
      PlcNo : 0,
      SetNo: 0,
      Speed: 0,

      selectDay: "",
      selectTime: "",
      name: "",
      id: -1,
  };
  return dt;
}


export const GetMeasureInfoType = (): Promise<MeasureInfoType[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/MeasuleInfo")
    .then((res) => res.json())
      .then((result: MeasureInfoType[]) => {
        if (MeasureInfoTypeListValidate(result)) resolve(result);
        reject('Invalidate response');
    },
      (error) => {
        console.log(error);
        reject(error);
      }
  );
  });
};

const MeasureInfoTypeListValidate = (data: MeasureInfoType[]) => {
    if (data === undefined) return false;
    return true;
  };

export const GetFeatureParameterDataType = (deviceNo: number, from: Date): Promise<FeatureParameterDataType[]> => {
  const url = `api/FeatureParameter?`;
  var param = "";
  param += `deviceNo=${deviceNo}&&`;
  param += `from=${dayjs(from).format("YYYY-MM-DD HH:mm:ss")}`;
  return new Promise((resolve, reject) => {
    fetch(`${ url }${ param }`)
    .then((res) => res.json())
      .then((result: FeatureParameterDataType[]) => {
        console.debug(`${ url }${ param }`);
        console.debug(result);
        if (FeatureParameterDataTypeValidate(result)) resolve(result);
        reject('Invalidate response');
    },
      (error) => {
        console.log(error);
        reject(error);
      }
  );
  });
};

const FeatureParameterDataTypeValidate = (data: FeatureParameterDataType[]) => {
    if (data === undefined) return false;
    return true;
  };
